import { render, staticRenderFns } from "./closing-item.vue?vue&type=template&id=98342852"
import script from "./closing-item.vue?vue&type=script&lang=js"
export * from "./closing-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports